var map = {
	"./Pagination/Pagination.vue": 644,
	"./animations/wave.vue": 6975,
	"./floatService/floatService.vue": 8971,
	"./myBreadcrumb/myBreadcrumb.vue": 2513,
	"./myBreadcrumb/phoneBreadcrumb.vue": 2328,
	"./myDeclaration/myDeclaration.vue": 9865,
	"./myDeclaration/phoneDeclaration.vue": 8189,
	"./myFooter/background/background.vue": 593,
	"./myFooter/myFooter.vue": 7853,
	"./myFooter/phoneFooter.vue": 1568,
	"./myHeader/myHeader.vue": 7151,
	"./myHeader/phoneHeader.vue": 473,
	"./myMenu/myMenu.vue": 2733,
	"./myMenu/phoneMenu.vue": 5833,
	"./myNumber/myNumber.vue": 6696,
	"./mySwiper/mySwiper.vue": 8600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4285;